<!--<p>edit-request-informasi-distributor works!</p>-->

<app-card-verification-form
  [isViewOnly]="true"
  [bodyData]="scopeSubject.value"
  [title]="'Cakupan'"
  [isLoading]="isLoading"
  [typeSection]="EnumCardVerificationSection.SCOPE"
/>

<app-card-verification-form
  [isViewOnly]="true"
  [bodyData]="ownerSubject.value"
  [title]="'Pemilik Usaha'"
  [isLoading]="isLoading"
  [typeSection]="EnumCardVerificationSection.OWNER"
  [type]="EnumCardVerificationForm.KTP"
/>

<app-card-verification-form
  [isViewOnly]="true"
  [bodyData]="managerSubject.value"
  [title]="'Pengelola Usaha'"
  [isLoading]="isLoading"
  [typeSection]="EnumCardVerificationSection.MANAGER"
  [type]="EnumCardVerificationForm.KTP"
/>

<app-card-verification-form
  [isViewOnly]="true"
  [bodyData]="businessInfoSubject.value"
  [title]="'Informasi Usaha'"
  [isLoading]="isLoading"
  [typeSection]="EnumCardVerificationSection.BUSINESS_INFORMATION"
  [type]="EnumCardVerificationForm.KTP"
/>
